import { render, staticRenderFns } from "./TableChicksUnMatch.vue?vue&type=template&id=5165e5d4&scoped=true"
import script from "./TableChicksUnMatch.vue?vue&type=script&lang=js"
export * from "./TableChicksUnMatch.vue?vue&type=script&lang=js"
import style0 from "./TableChicksUnMatch.vue?vue&type=style&index=0&id=5165e5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165e5d4",
  null
  
)

export default component.exports